import React, { useState } from 'react';
import { Menu, X, Users, MessageSquare, GitBranch, ChevronDown, UserSquare } from 'lucide-react';
const translations = {
  en: {
    dashboard: 'Dashboard',
    chat: 'Chatbot',
    workflow: 'Workflow',
    candidates: 'Candidates',
    languages: 'Languages',
    english: 'English',
    german: 'German',
    french: 'French',
    italian: 'Italian'
  },
  de: {
    dashboard: 'Dashboard',
    chat: 'Chatbot',
    workflow: 'Arbeitsablauf',
    candidates: 'Kandidaten',
    languages: 'Sprachen',
    english: 'Englisch',
    german: 'Deutsch',
    french: 'Französisch',
    italian: 'Italienisch'
  },
  fr: {
    dashboard: 'Tableau de bord',
    chat: 'Chatbot',
    workflow: 'Flux de travail',
    candidates: 'Candidats',
    languages: 'Langues',
    english: 'Anglais',
    german: 'Allemand',
    french: 'Français',
    italian: 'Italien'
  },
  it: {
    dashboard: 'Dashboard',
    chat: 'Chatbot',
    workflow: 'Flusso di lavoro',
    candidates: 'Candidati',
    languages: 'Lingue',
    english: 'Inglese',
    german: 'Tedesco',
    french: 'Francese',
    italian: 'Italiano'
  }
};
export function Header({
  activeTab,
  setActiveTab,
  language,
  setLanguage
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const t = translations[language];
  const languageFlags = {
    en: '🇬🇧',
    de: '🇩🇪',
    fr: '🇫🇷',
    it: '🇮🇹'
  };
  const getLanguageName = code => {
    switch (code) {
      case 'en':
        return t.english;
      case 'de':
        return t.german;
      case 'fr':
        return t.french;
      case 'it':
        return t.italian;
      default:
        return t.english;
    }
  };
  return <header className="bg-white shadow-md" data-id="element-325">
      <div className="container mx-auto px-4 py-3" data-id="element-326">
        <div className="flex justify-between items-center" data-id="element-327">
          <div className="flex items-center space-x-2" data-id="element-328">
            <div className="font-bold text-xl text-blue-600" data-id="element-329">Impresso</div>
            <div className="text-sm text-gray-500 hidden md:block" data-id="element-330">
              AI Hiring Assistant
            </div>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-331">
            <button className={`flex items-center space-x-1 ${activeTab === 'dashboard' ? 'text-blue-600 font-medium' : 'text-gray-600 hover:text-blue-500'}`} onClick={() => setActiveTab('dashboard')} data-id="element-332">
              <Users size={18} data-id="element-333" />
              <span data-id="element-334">{t.dashboard}</span>
            </button>
            <button className={`flex items-center space-x-1 ${activeTab === 'chat' ? 'text-blue-600 font-medium' : 'text-gray-600 hover:text-blue-500'}`} onClick={() => setActiveTab('chat')} data-id="element-335">
              <MessageSquare size={18} data-id="element-336" />
              <span data-id="element-337">{t.chat}</span>
            </button>
            <button className={`flex items-center space-x-1 ${activeTab === 'workflow' ? 'text-blue-600 font-medium' : 'text-gray-600 hover:text-blue-500'}`} onClick={() => setActiveTab('workflow')} data-id="element-338">
              <GitBranch size={18} data-id="element-339" />
              <span data-id="element-340">{t.workflow}</span>
            </button>
            <button className={`flex items-center space-x-1 ${activeTab === 'candidates' ? 'text-blue-600 font-medium' : 'text-gray-600 hover:text-blue-500'}`} onClick={() => setActiveTab('candidates')} data-id="element-341">
              <UserSquare size={18} data-id="element-342" />
              <span data-id="element-343">{t.candidates}</span>
            </button>
            <div className="relative" data-id="element-344">
              <button className="flex items-center space-x-1 text-gray-600 hover:text-blue-500" onClick={() => setLanguageMenuOpen(!languageMenuOpen)} data-id="element-345">
                <span data-id="element-346">{languageFlags[language]}</span>
                <span data-id="element-347">{getLanguageName(language)}</span>
                <ChevronDown size={16} data-id="element-348" />
              </button>
              {languageMenuOpen && <div className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-md shadow-lg z-10" data-id="element-349">
                  {Object.keys(languageFlags).map(code => <button key={code} className={`block w-full text-left px-4 py-2 text-sm ${language === code ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => {
                setLanguage(code);
                setLanguageMenuOpen(false);
              }} data-id="element-350">
                      <span className="mr-2" data-id="element-351">{languageFlags[code]}</span>
                      {getLanguageName(code)}
                    </button>)}
                </div>}
            </div>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden text-gray-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-352">
            {mobileMenuOpen ? <X size={24} data-id="element-353" /> : <Menu size={24} data-id="element-354" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {mobileMenuOpen && <nav className="mt-4 md:hidden" data-id="element-355">
            <div className="flex flex-col space-y-3" data-id="element-356">
              <button className={`flex items-center space-x-2 py-2 ${activeTab === 'dashboard' ? 'text-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => {
            setActiveTab('dashboard');
            setMobileMenuOpen(false);
          }} data-id="element-357">
                <Users size={18} data-id="element-358" />
                <span data-id="element-359">{t.dashboard}</span>
              </button>
              <button className={`flex items-center space-x-2 py-2 ${activeTab === 'chat' ? 'text-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => {
            setActiveTab('chat');
            setMobileMenuOpen(false);
          }} data-id="element-360">
                <MessageSquare size={18} data-id="element-361" />
                <span data-id="element-362">{t.chat}</span>
              </button>
              <button className={`flex items-center space-x-2 py-2 ${activeTab === 'workflow' ? 'text-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => {
            setActiveTab('workflow');
            setMobileMenuOpen(false);
          }} data-id="element-363">
                <GitBranch size={18} data-id="element-364" />
                <span data-id="element-365">{t.workflow}</span>
              </button>
              <button className={`flex items-center space-x-2 py-2 ${activeTab === 'candidates' ? 'text-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => {
            setActiveTab('candidates');
            setMobileMenuOpen(false);
          }} data-id="element-366">
                <UserSquare size={18} data-id="element-367" />
                <span data-id="element-368">{t.candidates}</span>
              </button>
              <div className="border-t border-gray-200 pt-2" data-id="element-369">
                <p className="text-sm text-gray-500 mb-2" data-id="element-370">{t.languages}:</p>
                <div className="grid grid-cols-2 gap-2" data-id="element-371">
                  {Object.keys(languageFlags).map(code => <button key={code} className={`flex items-center space-x-1 py-1 px-2 rounded ${language === code ? 'bg-blue-50 text-blue-600' : 'text-gray-700'}`} onClick={() => {
                setLanguage(code);
              }} data-id="element-372">
                      <span data-id="element-373">{languageFlags[code]}</span>
                      <span data-id="element-374">{getLanguageName(code)}</span>
                    </button>)}
                </div>
              </div>
            </div>
          </nav>}
      </div>
    </header>;
}